export default "__VITE_ASSET__22ad979a__"